
import {

    CHAT_USERS_REQUEST,
    CHAT_USERS_SUCCESS,
    CHAT_USERS_FAIL,



    SEND_PRIVATE_MESSAGE_REQUEST,
    SEND_PRIVATE_MESSAGE_SUCCESS,
    SEND_PRIVATE_MESSAGE_RESET,
    SEND_PRIVATE_MESSAGE_FAIL,



    GET_PRIVATE_CONVERSATIONS_REQUEST,
    GET_PRIVATE_CONVERSATIONS_SUCCESS,
    GET_PRIVATE_CONVERSATIONS_FAIL,


    SINGLE_CONVERSATION_REQUEST,
    SINGLE_CONVERSATION_SUCCESS,
    SINGLE_CONVERSATION_FAIL,

        CLEAR_CONVERSATION_REQUEST,
    CLEAR_CONVERSATION_SUCCESS,
    CLEAR_CONVERSATION_RESET,
    CLEAR_CONVERSATION_AIL,

    CLEAR_ERRORS,



} from "../constants/chatConstants"





export const getChatUserReducers = (state = {}, action) => {
    switch (action.type) {
        case CHAT_USERS_REQUEST:
            return { loading: true };

        case CHAT_USERS_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                users: action.payload.users,
                totalUsers: action.payload.totalUsers,

            };

        case CHAT_USERS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                productTypes: null
            };

        case CLEAR_ERRORS:
            return { ...state, error: null };

        default:
            return state;
    }
};



export const sendPrivateMessageReducer = (state = { chat: {} }, action) => {

    switch (action.type) {
        case SEND_PRIVATE_MESSAGE_REQUEST:

            return {
                loading: true,
            }

        case SEND_PRIVATE_MESSAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                message: action.payload.message,
                conversation_id: action.payload.conversation_id,
            }

        case SEND_PRIVATE_MESSAGE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                message: null // optional: clear old message
            }
        case SEND_PRIVATE_MESSAGE_RESET:
            return {
                ...state,
                loading: false,
                message: null // optional: clear old message

            }
        case CLEAR_ERRORS:

            return {
                ...state,
                error: null,
            }
        default:
            return state;
    }

}
export const getPrivateConversationsReducer = (state = { chat: {} }, action) => {

    switch (action.type) {
        case GET_PRIVATE_CONVERSATIONS_REQUEST:

            return {
                ...state,
                loading: true,
            }

        case GET_PRIVATE_CONVERSATIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                conversations: action.payload.conversations,
                totalConversations: action.payload.totalConversations,
            }

        case GET_PRIVATE_CONVERSATIONS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                conversations: null // optional: clear old message
            }
        case CLEAR_ERRORS:

            return {
                ...state,
                error: null,
            }
        default:
            return state;
    }

}
export const singleConversationsReducer = (state = { chat: {} }, action) => {

    switch (action.type) {
        case SINGLE_CONVERSATION_REQUEST:

            return {
                ...state, 
                loading: true,
            }

        case SINGLE_CONVERSATION_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                conversation: action.payload.conversation,
                participants: action.payload.participants,
                other_user: action.payload.other_user,
                messages: action.payload.messages,
                totalMessages: action.payload.totalMessages,
            }

        case SINGLE_CONVERSATION_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                conversation: null,// optional: clear old message
                participants: null,// optional: clear old message
                other_user: null,// optional: clear old message
                messages: null,// optional: clear old message
                totalMessages: null,// optional: clear old message
            }
        case CLEAR_ERRORS:

            return {
                ...state,
                error: null,
            }
        default:
            return state;
    }

}


export const clearConversationReducer = (state = { chat: {} }, action) => {

    switch (action.type) {
        case CLEAR_CONVERSATION_REQUEST:

            return {
                loading: true,
            }

        case CLEAR_CONVERSATION_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                message: action.payload.message,
            }

        case CLEAR_CONVERSATION_RESET:
            return {
                ...state,
                loading: false,
                error: action.payload,
                message: null // optional: clear old message
            }
        case CLEAR_CONVERSATION_AIL:
            return {
                ...state,
                loading: false,
                message: null // optional: clear old message

            }
        case CLEAR_ERRORS:

            return {
                ...state,
                error: null,
            }
        default:
            return state;
    }

}